import React, { useRef } from "react";
import Nav from "./Nav";
import "../index.css";

const Header = () => {
  const nextSectionRef = useRef(null);

  const scrollToNextSection = () => {
    nextSectionRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header className="header-section">
      <Nav />
      <div className="main">
        <div className="social-links">
          <a href="https://discord.gg/productionrp" title="Discord">
            <img src="https://media.productionrp.org/website/images/discord.svg" alt="Discord" className="social-icon" />
          </a>
          <a href="https://twitter.com/Production__RP" title="Twitter">
            <img src="https://media.productionrp.org/website/images/twitter.svg" alt="Twitter" className="social-icon" />
          </a>
          <a href="https://www.instagram.com/production__rp" title="Instagram">
            <img src="https://media.productionrp.org/website/images/instagram.svg" alt="Instagram" className="social-icon" />
          </a>
          <a href="https://www.tiktok.com/@productionrp" title="TikTok">
            <img src="https://media.productionrp.org/website/images/tiktok.svg" alt="TikTok" className="social-icon" />
          </a>
          <a href="https://www.threads.net/@productionrp" title="Threads">
            <img src="https://media.productionrp.org/website/images/threads.svg" alt="Threads" className="social-icon" />
          </a>
          <a href="https://www.twitch.tv/productionrp" title="Twitch">
            <img src="https://media.productionrp.org/website/images/twitch.svg" alt="Twitch" className="social-icon" />
          </a>
          <a href="https://www.youtube.com/@productionrp6933" title="YouTube">
            <img src="https://media.productionrp.org/website/images/youtube.svg" alt="YouTube" className="social-icon" />
          </a>
        </div>
        <div className="main-content">
          <h1>WELCOME TO PRODUCTIONRP</h1>
          <p>
            Dive into an exclusive roleplay server where exciting adventures,
            progressive stories, and endless fun await!
          </p>

          <div className="button-group">
            <button
              className="apply-button"
              onClick={() =>
                (window.location.href = "https://core.productionrp.org/apply")
              }
            >
              <img src="https://media.productionrp.org/website/images/pen.svg" alt="Apply" className="button-icon" /> APPLY
            </button>
            <button
              className="rules-button"
              onClick={() => (window.location.href = "/rules")}
            >
              <img src="https://media.productionrp.org/website/images/book.svg" alt="Rules" className="button-icon" /> RULES
            </button>
          </div>
          <div className="button-group festive-pulse-group">
            <button
              className="apply-button festive-pulse-button"
              onClick={() => (window.location.href = "/pulse")}
            >
              <span className="festive-icon">🎃</span>
              <img
                src="https://media.productionrp.org/website/images/megaphone.svg"
                alt="Pulse"
                className="button-icon pulse-megaphone-icon"
                style={{ transform: 'rotate(-18deg)' }}
              />
              <span>PULSE</span>
              <span className="festive-icon">🍂</span>
            </button>
            <div className="festive-pulse-footnote">
              <span className="pulse-date">Updated Today (Oct 17, 2026)</span>
              <span className="pulse-sep">&bull;</span>
              <span className="pulse-status">Fall Dev Update Live</span>
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-div" onClick={scrollToNextSection}>
        <div className="arrow">&#x21e9;</div>
        <p className="scroll-text">SCROLL FOR MORE</p>
      </div>
      <div ref={nextSectionRef} className="next-section">
        { }
      </div>
    </header>
  );
};

export default Header;
